import React, { useState } from 'react';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would typically send the data to your backend
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="mt-20 pt-20 pb-16 bg-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-elegant font-bold text-black mb-6 fade-in-up">
            Contact Us
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed fade-in-up delay-200">
            Get in touch with us for any inquiries about our jewellery collection, custom orders, or general questions.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-amber-100 rounded-2xl shadow-xl p-8 border border-amber-200 hover-lift fade-in-left">
            <h3 className="text-2xl font-semibold text-black mb-6">Send us a Message</h3>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-amber-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors bg-white hover:border-amber-400"
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-amber-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors bg-white hover:border-amber-400"
                  placeholder="Enter your email address"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="w-full px-4 py-3 border border-amber-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent transition-colors resize-none bg-white hover:border-amber-400"
                  placeholder="Tell us about your inquiry..."
                />
              </div>

              <button
                type="submit"
                className="w-full bg-black hover:bg-gray-800 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl hover-lift"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8 fade-in-right">
            <div>
              <h3 className="text-2xl font-semibold text-black mb-6">Get in Touch</h3>
              <p className="text-gray-600 mb-6">
                We'd love to hear from you! Whether you have questions about our jewellery collection, 
                want to place a custom order, or just want to say hello, we're here to help.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4 stagger-item" style={{ animationDelay: '0.1s' }}>
                <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center flex-shrink-0 scale-in">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1">Visit Our Store</h4>
                  <p className="text-gray-600">123 Jewellery Lane<br />Fashion District<br />New York, NY 10001</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 stagger-item" style={{ animationDelay: '0.2s' }}>
                <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center flex-shrink-0 scale-in">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1">Email Us</h4>
                  <p className="text-gray-600">info@svaryn.com<br />orders@svaryn.com</p>
                </div>
              </div>

              <div className="flex items-start space-x-4 stagger-item" style={{ animationDelay: '0.3s' }}>
                <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center flex-shrink-0 scale-in">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1">Call Us</h4>
                  <p className="text-gray-600">+1 (555) 123-4567<br />Mon-Fri: 9AM-6PM</p>
                </div>
              </div>
            </div>

            <div className="bg-amber-200 rounded-xl p-6 hover-lift stagger-item" style={{ animationDelay: '0.4s' }}>
              <h4 className="font-semibold text-black mb-3">Business Hours</h4>
              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex justify-between">
                  <span>Monday - Friday</span>
                  <span>9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday</span>
                  <span>10:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday</span>
                  <span>Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
